<template>
  <transition>
    <div class="contact DivImage" :style="{background: 'url('+ backgroungImg +') no-repeat'}">
      <img src="../assets/image/logo-light.png" alt="logo" class="logo-dark">
      <info-header :type="'4'"></info-header>
      <div class="infoGroup" style="min-height: calc(100vh - 265px)">
        <!-- <div class="title">CONTACT</div>
        <div class="box" v-for="(item, index) in infoItems" :key="index">
          <p class="address">{{item.title}}</p>
          <p>{{item.address}}</p>
          <p>{{item.tel}}</p>
          <p>{{item.email}}</p>
        </div> -->
        <div id="editor" @selectstart.stop @contextmenu.stop></div>
        <div class="contact-btn-wrapper">
          <Button type="primary" shape="circle" size="large" icon="ios-mail" @click="modalVisible = true">CONTACT US</Button>
        </div>

        <Modal
          v-model="modalVisible"
          title="Contact Us"
          :footer-hide="true"
          :mask-closable="false"
          @on-cancel="handleReset('formContact')"
          class-name="vertical-center-modal">
          <Form ref="formContact" :model="formContact" :rules="ruleContact" label-position="top">
            <FormItem label="Project Name" prop="projectName">
              <Input v-model="formContact.projectName" placeholder="Enter project name"></Input>
            </FormItem>
            <FormItem label="Contact Name" prop="contactName">
              <Input v-model="formContact.contactName" placeholder="Enter your name"></Input>
            </FormItem>
            <FormItem label="Title" prop="title">
              <Input v-model="formContact.title" placeholder="Enter your title"></Input>
            </FormItem>
            <FormItem label="Email" prop="email">
              <Input v-model="formContact.email" placeholder="Enter your email"></Input>
            </FormItem>
            <FormItem label="Timeline" prop="timeline">
              <DatePicker type="daterange" :placement="isMobile ? 'bottom' : 'bottom-end'" placeholder="Select timeline" style="width: 100%" v-model="formContact.timeline" :editable="false" :transfer="true"></DatePicker>
            </FormItem>
            <FormItem label="Scope of Work" prop="scope">
              <Input v-model="formContact.scope" type="textarea" :autosize="{minRows: 3,maxRows: 5}" placeholder="Describe the scope of work..."></Input>
            </FormItem>
            <FormItem>
              <div style="display: flex; justify-content: center;">
                <Button
                  type="primary"
                  @click="handleSubmit('formContact')"
                  style="background-color: rgba(211, 93, 30, 0.8); border-color: #d35d1e;width: 100%;"
                  :loading="loading"
                >
                  Submit
                </Button>
              </div>
            </FormItem>
          </Form>
        </Modal>
      </div>
      <info-footer :isStatic="true"></info-footer>
    </div>
  </transition>
</template>

<script>
import InfoHeader from '../components/infoHeader.vue'
import InfoFooter from '../components/infoFooter.vue'
import BgDefault from '../assets/image/contact01.jpg'

import E from 'wangeditor'
import moment from 'moment'

export default {
  name: 'Contact',
  // meta
  metaInfo: {
    title: 'FTG Studio - Contact',
    meta: [
      { name: 'description', content: 'Find full business contact details for architectural visualization service inquiry, architectural rendering project consultation, cooperation discussion and quotation requests. It includes official business email, studio location and online message form, enabling global architecture practices to easily reach us for CGI rendering, architectural animation and design visualization collaboration.' }
    ]
  },
  components: {
    InfoHeader, InfoFooter
  },
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      backgroungImg: '',
      BgDefault: BgDefault,
      backgroungImgArr: [],
      bgIndex: 0,
      infoItems: [
        { 
          title: 'HONG KONG',
          address: "Room 2209, 22/F, Wu Chung House, 213 Queen's Read East, Wanchai, Hong Kong",
          tel: 'Tel: 852-54461903, Fax: 852-30202672',
          email: 'Email: info@ftgstudio.com'
        },
        { 
          title: 'SHANGHAI',
          address: "Room 1109, Guokang Road 46, Shanghai, China",
          tel: 'Tel: 086-021-59189020, Mobile: 086-18616315053',
          email: 'Email: info@ftgstudio.com'
        }
      ],
      timer: null,
      modalVisible: false,
      loading: false,
      formContact: {
        projectName: '',
        contactName: '',
        title: '',
        email: '',
        timeline: [],
        scope: ''
      },
      // 全部必填
      ruleContact: {
        projectName: [
          { required: true, message: 'Project Name is required', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: 'Contact Name is required', trigger: 'blur' }
        ],
        title: [
          { required: true, message: 'Title is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ],
        timeline: [
          { required: true, message: 'Timeline is required', trigger: 'change', type: 'array' },
          { validator: (rule, value, callback) => {
            if(!value || value.length !== 2 || !value[0] || !value[1]){
              callback(new Error('Timeline is required'));
            }else{
              callback();
            }
          }, trigger: 'change' }
        ],
        scope: [
          { required: true, message: 'Scope of work is required', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true;
          const Params = {
            projectName: this.formContact.projectName,
            contactName: this.formContact.contactName,
            title: this.formContact.title,
            email: this.formContact.email,
            beginDate: this.formContact.timeline[0] ? moment(this.formContact.timeline[0]).format('YYYY-MM-DD') : '',
            endDate: this.formContact.timeline[1] ? moment(this.formContact.timeline[1]).format('YYYY-MM-DD') : '',
            description: this.formContact.scope,
          }

          // this.$api.sendMessage(Params).then(res => {
          //   if(res.rescode == 0){
          //     this.$Message.success('Submit Success!');
          //     this.modalVisible = false;
          //     this.$refs[name].resetFields();
          //   }else{
          //     this.$Message.error(res.msg);
          //   }
          // }).finally(() => {
          //   this.loading = false;
          // })
          this.$api.sendMessage(Params)
          setTimeout(() => {
            this.$Message.success('Submit Success!');
            this.modalVisible = false;
            this.$refs[name].resetFields();
            this.loading = false;
          }, 1500);
        } else {
          this.loading = false;
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields();
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    }
  },
  mounted() {
    const that = this
    // 创建富文本编辑器
    that.editor = new E('#editor');

    // 配置服务器端地址
    that.editor.customConfig.uploadImgServer = `${process.env.API_HOST}/upload/index.php`;
    // 将图片大小限制为 10M
    that.editor.customConfig.uploadImgMaxSize = 1024 * 1024 * 10;
    
    that.editor.customConfig.uploadFileName = 'imageFile';
    that.editor.customConfig.uploadImgHooks = {
      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result, editor) {
        var url = result.pic;
        insertImg(url)
      }
    }
    that.editor.customConfig.customAlert = function (info) {
      // info 是需要提示的内容
      that.$Message.warning(info);
    }
    
    // 自定义菜单配置
    that.editor.customConfig.menus = [
      'head',  // 标题
      'bold',  // 粗体
      'fontSize',  // 字号
      'fontName',  // 字体
      'italic',  // 斜体
      'underline',  // 下划线
      'strikeThrough',  // 删除线
      'foreColor',  // 文字颜色
      'backColor',  // 背景颜色
      'link',  // 插入链接
      'list',  // 列表
      'justify',  // 对齐方式
      'quote',  // 引用
      'emoticon',  // 表情
      'image',  // 插入图片
      'table',  // 表格
      'code',  // 插入代码
      'undo',  // 撤销
      'redo'  // 重复
    ]

    that.editor.create();
    document.querySelector("#editor .w-e-text").contentEditable = false;
  },
  created(){
    const that = this
    let Data = {
      // token: that.token
    }
    that.$api.getContactInfo(Data).then(res => {
      if(res.rescode == 0){
        that.editor.txt.html(res.contact);
        that.backgroungImgArr = res.contactUrl

        if(that.backgroungImgArr && that.backgroungImgArr.length > 0){
          that.backgroungImg = that.backgroungImgArr[that.bgIndex].url
        }else{
          // that.backgroungImg = that.BgDefault
        }

        that.timer = setInterval(function() {
          if(that.backgroungImgArr && that.backgroungImgArr.length > 0){
            that.backgroungImg = that.backgroungImgArr[that.bgIndex].url
            
            if(that.bgIndex == that.backgroungImgArr.length - 1){
              that.bgIndex = 0
            }else{
              that.bgIndex ++
            }
          }else{
            clearInterval(that.timer);
          }
        }, 10000);
      }
    }).catch(err => {});

    
  },
  beforeRouteLeave (to, from, next) {
    if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
    next()
  }
}
</script>

<style scoped lang="less">
  @import '../assets/css/main.less';

  .contact-btn-wrapper {
    margin-top: 30px;
    text-align: center;

    display: flex;
    justify-content: center;
    button {
      padding: 10px 40px;
      font-size: 16px;
      letter-spacing: 2px;
      background-color: rgba(211, 93, 30, 0.8);
      border-color: #d35d1e;
      
      &:hover {
        background-color: #d35d1e;
        border-color: #d35d1e;
      }
    }
  }
</style>

<style lang="less">
  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
      top: 0;
    }

    .ivu-modal-content {
      background-color: rgba(255, 255, 255, 0.5); /* Semi-transparent white */
      backdrop-filter: blur(20px) saturate(180%); /* iOS blur effect */
      -webkit-backdrop-filter: blur(20px) saturate(180%);
      border-radius: 20px;
      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.4);
      
      /* Ensure text is readable */
      .ivu-modal-header {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .ivu-modal-header-inner {
          color: #333;
          font-weight: 600;
        }
      }
      
      .ivu-modal-close {
        .ivu-icon-ios-close {
          color: #333;
        }
      }

      .ivu-form-item-label {
        color: #333;
        font-weight: 500;
      }
      
      /* Input styling to match */
      .ivu-input {
        background-color: rgba(255, 255, 255, 0.5);
        border: 1px solid rgba(0, 0, 0, 0.1);
        color: #333;
        border-radius: 8px;
        
        &:focus {
          background-color: rgba(255, 255, 255, 0.8);
          box-shadow: 0 0 0 2px rgba(211, 93, 30, 0.2);
          border-color: #d35d1e;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .contact-btn-wrapper {
      margin-top: 20px;
      padding: 0 10px;
      
      button {
        padding: 8px 24px;
        font-size: 14px;
        width: auto;
        max-width: 90vw;
      }
    }

    .vertical-center-modal {
      .ivu-modal {
        width: 100% !important;
        margin: 0;
        height: 100%;
        top: 0;
      }
      
      .ivu-modal-content {
        padding: 10px;
        height: 100%;
        border-radius: 0; /* Remove corners for full screen */
        display: flex;
        flex-direction: column;
      }
      
      .ivu-modal-body {
        overflow-x: hidden;
        flex: 1;
        overflow-y: auto; /* Enable scrolling */
        -webkit-overflow-scrolling: touch;
      }
    }

    /* DatePicker mobile optimization */
    .ivu-picker-panel-body {
      max-width: calc(100vw - 40px) !important;
    }
    
    .ivu-date-picker-cells {
      font-size: 12px !important;
    }
    
    .ivu-picker-panel {
      margin: 0 auto !important;
      max-width: 90vw !important;
    }
    
    .ivu-date-picker {
      .ivu-picker-panel-content {
        padding: 5px !important;
      }
    }

    /* For daterange picker - optimize the dual calendar layout */
    .ivu-picker-panel-body-wrapper {
      display: flex;
      flex-direction: column !important;
      
      .ivu-picker-panel-body {
        width: 100% !important;
        
        &:first-child {
          margin-bottom: 10px;
        }
      }
    }
    
    /* Optimize date picker cells for touch */
    .ivu-date-picker-cells-cell {
      padding: 8px 4px !important;
    }
    
    /* Make sure dropdown doesn't overflow */
    .ivu-select-dropdown {
      max-width: 90vw !important;
    }
  }

  /* 超小屏幕优化（< 450px） */
  @media screen and (max-width: 450px) {
    .contact-btn-wrapper {
      margin-top: 15px;
      padding: 0 5px;
      
      button {
        padding: 8px 16px !important;
        font-size: 12px !important;
        width: auto !important;
        max-width: 85vw !important;
        min-height: 40px;
        word-wrap: break-word;
        white-space: normal;
      }

      .ivu-icon-ios-mail {
        font-size: 18px !important;
        margin-right: 5px !important;
      }
    }

    .vertical-center-modal {
      .ivu-modal-content {
        padding: 8px !important;
      }
      
      .ivu-modal-header-inner {
        font-size: 16px !important;
      }
      
      .ivu-form-item-label {
        font-size: 12px !important;
      }
      
      .ivu-input {
        font-size: 12px !important;
      }
    }

    .ivu-btn {
      .ivu-icon-ios-mail {
        font-size: 18px !important;
        margin-right: 4px !important;
      }
    }
  }

  .ivu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    
    .ivu-icon-ios-mail {
      font-size: 25px;
      margin-right: 8px;
      flex-shrink: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue